import * as tslib_1 from "tslib";
import { BasicModel } from './basic.model';
import { State } from '@sc/portal.fe.lib.app-components';
var City = /** @class */ (function (_super) {
    tslib_1.__extends(City, _super);
    function City(data) {
        return _super.call(this, tslib_1.__assign({ state: new State() }, data)) || this;
    }
    return City;
}(BasicModel));
export { City };
